const orderApprovePageHelperData = {
  form: {
    monthPay: 0, // 月供
    che300Mid: null, // 车300的车型id
    floatingPro: null, // 二手车车价上浮比例
    loanRemarks: null, // 编辑页 - 复审审批备注
    fyRemarks: null, // 编辑页 - 复议备注
    extendName: null // 复审页 - 延保费用
  },
  upload: {
    title: null
  },
  area: {
    proposer: { // 省、市、区
      home: [],
      now: [],
      work: []
    },
    guarantee: { // 省、市、区
      home: [],
      now: [],
      work: []
    },
    relative: { // 省、市、区
      home: [],
      now: []
    },
    loanAccount: [] // 省、市
  },
  contract: {
    damageLessPrice: null, // 车损盗抢最低额
    carSharePrice: null, // 车享包费用
    totalFinancing: null, // 融资总额
    specialRemarks: '宝德融资租赁（上海）有限公司为本保单第一受益人，未经其事先书面同意，本保单不得退保/减保或批改（不影响第一受益人权益的批改除外）；当一次事故的保险赔款高于人民币5000元时，保险人须征得第一受益人书面同意后方可对被保险人支付。'
  }
}

export {
  orderApprovePageHelperData
}



// WEBPACK FOOTER //
// ./src/assets/js/page/approval/refs/approve.page.helper.js